import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 14.41l-3.71-3.7 1.42-1.42L9 11.59l5.29-5.3 1.42 1.42L9 14.41zM17 2H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
});

var SvgEnableSelectionMinor = function SvgEnableSelectionMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgEnableSelectionMinor as S };
